var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container",style:({
      opacity: _vm.screensaverOpacity,
      transform: `scale(${_vm.screensaverOpacity * 0.1 + 0.9})`,
      backgroundImage:
        'url(https://essen.frechdax-abdl.de/flyer/2025-11-22_001_Main_Thumb.jpg)',
    })}),_c('div',{staticClass:"flyer-bg",style:({
      opacity: _vm.screensaverOpacity,
      backgroundImage:
        'url(https://essen.frechdax-abdl.de/flyer/2025-11-22_001_Blur_Thumb.jpg)',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }